import session from 'models/sessionInstance';
import fetchOncePromise from 'libraries/fetchOncePromise';

export default fetchOncePromise(session);
